<script lang="ts">
</script>

<div class="absolute left-1/2 top-1/2 z-10 h-8 w-8 -translate-x-1/2 -translate-y-1/2 opacity-50">
  <!-- Left -->
  <div class="absolute bottom-[35%] left-0 h-[32%] w-[52%] skew-y-[-35deg] overflow-hidden">
    <div class="_animated-bar-1 absolute left-0 top-0 h-full w-full bg-current"></div>
    <div class="_animated-bar-2 absolute left-0 top-0 h-full w-full bg-current"></div>
  </div>
  <!-- Right -->
  <div class="absolute bottom-[35%] right-0 h-[32%] w-[52%] skew-y-[-35deg] overflow-hidden">
    <div class="_animated-bar-3 absolute left-0 top-0 h-full w-full bg-current"></div>
    <div class="_animated-bar-4 absolute left-0 top-0 h-full w-full bg-current"></div>
  </div>
</div>

<style lang="postcss">
  ._animated-bar-1 {
    animation: swipeBar1 2.5s cubic-bezier(0.65, 0, 0.35, 1) infinite;
    animation-fill-mode: both;
    transform-origin: center left;
  }

  ._animated-bar-2 {
    animation: swipeBar2 2.5s cubic-bezier(0.65, 0, 0.35, 1) infinite;
    animation-fill-mode: both;
    transform-origin: center right;
    animation-delay: 1.25s;
  }
  ._animated-bar-3 {
    animation: swipeBar1 2.5s cubic-bezier(0.65, 0, 0.35, 1) infinite;
    animation-fill-mode: both;
    transform-origin: center left;
    animation-delay: 0.25s;
  }

  ._animated-bar-4 {
    animation: swipeBar2 2.5s cubic-bezier(0.65, 0, 0.35, 1) infinite;
    animation-fill-mode: both;
    transform-origin: center right;
    animation-delay: 1.5s;
  }

  @keyframes swipeBar1 {
    0% {
      transform: scaleX(0) translateX(-100%);
    }
    30% {
      transform: scaleX(1) translateX(0%);
    }
    45% {
      transform: scaleX(1) translateX(0%);
    }
    75% {
      transform: scaleX(0) translateX(-100%);
    }
    90% {
      transform: scaleX(0) translateX(-100%);
    }
    100% {
      transform: scaleX(0) translateX(-100%);
    }
  }

  @keyframes swipeBar2 {
    0% {
      transform: scaleX(0) translateX(100%);
    }
    30% {
      transform: scaleX(1) translateX(0%);
    }
    45% {
      transform: scaleX(1) translateX(0%);
    }
    75% {
      transform: scaleX(0) translateX(100%);
    }
    90% {
      transform: scaleX(0) translateX(100%);
    }
    100% {
      transform: scaleX(0) translateX(100%);
    }
  }
</style>
